import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  settingsCardTitle: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.settingsCardTitle`,
    defaultMessage: 'Rehire Check Stage Settings',
  },
  connectorLabel: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.connectorLabel`,
    defaultMessage: 'HRIS connector',
  },
  connectorPlaceholder: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.connectorPlaceholder`,
    defaultMessage: 'Select a connector',
  },
  connectorAutoSelectedHelperText: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.connectorAutoSelectedHelperText`,
    defaultMessage: 'Auto-selected — one active HRIS connector',
  },
  zeroConnectorsNotice: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.zeroConnectorsNotice`,
    defaultMessage: 'Connect an HRIS in the Connector Marketplace first',
  },
  eligibilityFieldLabel: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.eligibilityFieldLabel`,
    defaultMessage: 'Eligibility field',
  },
  eligibilityFieldHelperText: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.eligibilityFieldHelperText`,
    defaultMessage: 'Must match the custom field key mapped on your connector',
  },
  eligibleValuesLabel: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.eligibleValuesLabel`,
    defaultMessage: 'Values that mean eligible',
  },
  eligibleValuesHelperText: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.eligibleValuesHelperText`,
    defaultMessage: 'Anything else — including blank — is not eligible',
  },
  eligibleValuesPlaceholder: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.eligibleValuesPlaceholder`,
    defaultMessage: 'Type a value and press enter',
  },
  onUnavailableLabel: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.onUnavailableLabel`,
    defaultMessage: 'If the check cannot complete',
  },
  onUnavailableHold: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.onUnavailableHold`,
    defaultMessage: 'Keep applicant on this stage (recommended)',
  },
  onUnavailableContinue: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.onUnavailableContinue`,
    defaultMessage: 'Continue to the rules below',
  },
  shadowModeLabel: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.shadowModeLabel`,
    defaultMessage: "Shadow mode — log the verdict only, don't hold or route",
  },
  shadowModeHelperText: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.shadowModeHelperText`,
    defaultMessage:
      'For testing — verdicts are recorded but never hold or route the applicant',
  },
  dryRunCardTitle: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.dryRunCardTitle`,
    defaultMessage: 'Test this configuration',
  },
  dryRunDescription: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.dryRunDescription`,
    defaultMessage:
      "Runs the current settings against your HRIS without creating an applicant",
  },
  dryRunEmailLabel: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.dryRunEmailLabel`,
    defaultMessage: 'Email',
  },
  dryRunSsnLabel: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.dryRunSsnLabel`,
    defaultMessage: 'SSN last 4 (optional)',
  },
  dryRunButton: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.dryRunButton`,
    defaultMessage: 'Run test',
  },
  dryRunResultRawValueLabel: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.dryRunResultRawValueLabel`,
    defaultMessage: 'Raw field value',
  },
  dryRunResultStatusLabel: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.dryRunResultStatusLabel`,
    defaultMessage: 'Employment status',
  },
  dryRunResultTerminationDateLabel: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.dryRunResultTerminationDateLabel`,
    defaultMessage: 'Termination date',
  },
  dryRunResultDataAsOfLabel: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.dryRunResultDataAsOfLabel`,
    defaultMessage: 'Data as of',
  },
  dryRunErrorMessage: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.dryRunErrorMessage`,
    defaultMessage:
      "We couldn't reach the test tool. Check your connection and try again.",
  },
  verdictEligible: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.verdictEligible`,
    defaultMessage: 'Eligible',
  },
  verdictNotEligible: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.verdictNotEligible`,
    defaultMessage: 'Not eligible',
  },
  verdictNoMatch: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.verdictNoMatch`,
    defaultMessage: 'No match',
  },
  verdictAmbiguous: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.verdictAmbiguous`,
    defaultMessage: 'Ambiguous match',
  },
  verdictUnavailable: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.verdictUnavailable`,
    defaultMessage: "Can't verify",
  },
  verdictFieldNotMapped: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.verdictFieldNotMapped`,
    defaultMessage: 'Field not mapped',
  },
  ruleOrderingHint: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.RehireCheckStage.ruleOrderingHint`,
    defaultMessage:
      'Rules evaluate top-down. If you route on currently employed, place it above eligible — an eligible current employee matches both.',
  },
});
